import { render } from "./TrainingLoadCaloricCalculator.vue?vue&type=template&id=2a41afe8&scoped=true"
import script from "./TrainingLoadCaloricCalculator.vue?vue&type=script&lang=js"
export * from "./TrainingLoadCaloricCalculator.vue?vue&type=script&lang=js"

import "./TrainingLoadCaloricCalculator.vue?vue&type=style&index=0&id=2a41afe8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a41afe8"]])

export default __exports__